import React, { useState, useRef } from "react";
import { View, Text, TextInput, StyleSheet, Animated, Image } from "react-native";

const FloatingLabelInput = ({ label, value, onChangeText, keyboardType, icon, iconStyle }) => {
  const [isFocused, setIsFocused] = useState(false);
  const labelPosition = useRef(new Animated.Value(value ? 1 : 0)).current;

  const handleFocus = () => {
    setIsFocused(true);
    Animated.timing(labelPosition, {
      toValue: 1,
      duration: 200,
      useNativeDriver: false,
    }).start();
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (!value) {
      Animated.timing(labelPosition, {
        toValue: 0,
        duration: 200,
        useNativeDriver: false,
      }).start();
    }
  };

  return (
    <View style={styles.container}>
      <Animated.Text
        style={[
          styles.label,
          {
            top: labelPosition.interpolate({
              inputRange: [0, 1],
              outputRange: [15, -8], // Moves label above input
            }),
            fontSize: labelPosition.interpolate({
              inputRange: [0, 1],
              outputRange: [15, 12], // Shrinks label when active
            }),
            color: "#aaa",
          },
        ]}
      >
        {label}
      </Animated.Text>

      <View style={styles.inputContainer}>
        <TextInput
          style={[
            styles.input,
            {
              paddingRight: icon ? 40 : 12, // Space for icon on right
            },
          ]}
          value={value}
          onChangeText={onChangeText}
          onFocus={handleFocus}
          onBlur={handleBlur}
          keyboardType={keyboardType}
        />
        {icon && <Image source={icon} style={[styles.icon, iconStyle]} />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
    marginBottom: 20,
  },
  label: {
    position: "absolute",
    left: 12,
    backgroundColor: "#fff",
    paddingHorizontal: 4,
    zIndex: 10,
    pointerEvents: "none",
  },
  inputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1.5,
    borderColor: "lightgray",
    borderRadius: 8,
    backgroundColor: "#fff",
    height: 48,
    paddingHorizontal: 12,
  },
  input: {
    flex: 1,
    fontSize: 16,
    height: "100%",
    paddingTop: 2,
  },
  icon: {
    tintColor: "#aaa",
    position: "absolute",
    right: 12, // Moves icon to right inside input
  },
});

export default FloatingLabelInput;
